import { TypographyProps, useBoolean } from '@amzn/ring-ui-react-components';

export const useNumberOfLines = (lines: TypographyProps['noOfLines']) => {
  const [clamped, { on, off }] = useBoolean(true);

  return [clamped ? lines : undefined, { clamp: on, unclamp: off }] as const;
};
